/**
 * 现代前端技术栈初始化脚本
 * 集成：Vue3、Tailwind CSS、GSAP、Lottie、Three.js、Phosphor Icons、Lucide Icons
 */

(function() {
  'use strict';

  // ========== 1. Tailwind CSS ==========
  // 已关闭 CDN 加载，避免控制台 “should not be used in production” 警告。
  // 若需 Tailwind 工具类，请使用 assets/modern-enhancements.css 或通过 PostCSS/CLI 构建。

  // ========== 2. Vue3 (CDN - 使用 prod 构建避免控制台开发版警告) ==========
  if (!window.Vue && !document.querySelector('script[src*="vue"]')) {
    const vueScript = document.createElement('script');
    vueScript.src = 'https://unpkg.com/vue@3/dist/vue.global.prod.js';
    vueScript.onload = function() {
      // 初始化 Vue 应用（可选，用于特定区域）
      window.initVueComponents = function() {
        // 可以在这里初始化 Vue 组件
      };
    };
    document.head.appendChild(vueScript);
  }

  // ========== 3. GSAP + ScrollTrigger ==========
  if (!window.gsap && !document.querySelector('script[src*="gsap"]')) {
    const gsapScript = document.createElement('script');
    gsapScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    gsapScript.onload = function() {
      const scrollTriggerScript = document.createElement('script');
      scrollTriggerScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
      scrollTriggerScript.onload = function() {
        gsap.registerPlugin(ScrollTrigger);
        // 初始化滚动动画
        initScrollAnimations();
      };
      document.head.appendChild(scrollTriggerScript);
    };
    document.head.appendChild(gsapScript);
  }

  // ========== 4. Lottie ==========
  if (!window.lottie && !document.querySelector('script[src*="lottie"]')) {
    const lottieScript = document.createElement('script');
    lottieScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
    lottieScript.onload = function() {
      initLottieAnimations();
    };
    document.head.appendChild(lottieScript);
  }

  // ========== 5. Three.js ==========
  if (!window.THREE && !document.querySelector('script[src*="three"]')) {
    const threeScript = document.createElement('script');
    threeScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    threeScript.onload = function() {
      // 可以在这里初始化 3D 场景（如果需要）
    };
    document.head.appendChild(threeScript);
  }

  // ========== 6. Phosphor Icons ==========
  if (!document.querySelector('link[href*="phosphor"]')) {
    const phosphorLink = document.createElement('link');
    phosphorLink.rel = 'stylesheet';
    phosphorLink.href = 'https://unpkg.com/@phosphor-icons/web@2.1.1/src/regular/style.css';
    document.head.appendChild(phosphorLink);
  }

  // ========== 7. Lucide Icons ==========
  if (!window.lucide && !document.querySelector('script[src*="lucide"]')) {
    const lucideScript = document.createElement('script');
    lucideScript.src = 'https://unpkg.com/lucide@latest/dist/umd/lucide.js';
    lucideScript.onload = function() {
      // 初始化图标
      if (window.lucide) {
        lucide.createIcons();
      }
    };
    document.head.appendChild(lucideScript);
  }

  // ========== 8. Framer Motion (通过 GSAP 实现类似效果，或使用 CDN) ==========
  // 注意：Framer Motion 主要用于 React，这里我们用 GSAP 实现类似动效

  // ========== 辅助函数：初始化滚动动画 ==========
  function initScrollAnimations() {
    if (!window.gsap || !window.ScrollTrigger) return;

    // 为商品卡片添加滚动进入动画
    gsap.utils.toArray('.product-card-wrapper, .card').forEach((card, i) => {
      gsap.from(card, {
        opacity: 0,
        y: 50,
        duration: 0.8,
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        },
        delay: i * 0.1,
      });
    });

    // Hero 区域动画
    const heroSection = document.querySelector('.slideshow, .image-banner');
    if (heroSection) {
      gsap.from(heroSection.querySelector('h1, .h0, .h1'), {
        opacity: 0,
        y: 30,
        duration: 1,
        ease: 'power3.out',
      });
    }
  }

  // ========== 辅助函数：初始化 Lottie 动画 ==========
  function initLottieAnimations() {
    if (!window.lottie) return;

    // 查找所有带有 data-lottie 属性的元素
    document.querySelectorAll('[data-lottie]').forEach((el) => {
      const animationPath = el.getAttribute('data-lottie');
      if (animationPath) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: animationPath,
        });
      }
    });
  }

  // ========== CSS Houdini 支持检测 ==========
  if (CSS.supports('background: paint(worklet)')) {
    // 可以在这里注册 CSS Paint Worklet
  }

  // ========== 响应式工具函数 ==========
  window.responsiveUtils = {
    // 使用 clamp() 的响应式字体大小
    clampFont: function(min, preferred, max) {
      return `clamp(${min}px, ${preferred}vw, ${max}px)`;
    },
    // Container Queries 检测
    supportsContainerQueries: CSS.supports('container-type: inline-size'),
  };

  // ========== 页面加载完成后初始化 ==========
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initAfterLoad, 100);
    });
  } else {
    setTimeout(initAfterLoad, 100);
  }

  function initAfterLoad() {
    // 确保所有库加载完成后再初始化
    if (window.lucide) {
      lucide.createIcons();
    }
  }
})();
